import AutoPayTag from "./AutoPayTag";

export default AutoPayTag;
